import {ChangeDetectionStrategy, Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';

require('./bringoz-linear-progress.scss');
@Component({
  standalone: false,
  selector: 'app-bringoz-linear-progress',
  templateUrl: './bringoz-linear-progress.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BringozLinearProgressComponent implements OnInit, OnChanges {

  @Input() value: number;
  @Input() isDisableSeverity: boolean;
  public severity: string; // low, mid, high

  constructor() {
  }

  ngOnInit() {
    this._setValue();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.value && !changes.value.isFirstChange()) {
      this._setValue();
    }
  }

  private _setValue() {
    this.severity = (this.value < 50) ? 'low' : ((this.value >= 50 && this.value < 85) ? 'mid' : 'high');
  }

}
